/*eslint-disable*/
import {
  Card,
  CardContent,
  FormControl,
  Grid,
  Typography,
  Checkbox
} from "@material-ui/core";
import GridItem from "components/Grid/GridItem.jsx";
import FormCheckbox from "components/Wrappers/materialUIWrappers/components/FormCheckbox.jsx";
import FormDropdown from 'components/Wrappers/materialUIWrappers/components/FormDropDown';
import FormInput from "components/Wrappers/materialUIWrappers/components/FormInput";
import _ from "lodash";
import React, { Fragment } from "react";
import { Field, change } from "redux-form";
import store from "store";
import CustomCardHeading from "../components/CustomCardHeading";
import NumberInput from "components/Wrappers/materialUIWrappers/components/NumberInput";
import { dateValid, isEmptyOrSpaces } from "helpers/ValidationHelpers";
import { ParseDMYwSlashes } from "helpers/DateHelpers";
import GetIdInformation, { idNumberValid } from "helpers/GetIdInformation";
import moment from "moment";

const required = value => (value ? undefined : "Required");


const CustomFieldMed = props => (
	<GridItem xs={4} sm={4} md={2} style={{ marginTop: '-25px' }}>
		<FormControl fullWidth>
			<Field {...props} />
		</FormControl>
	</GridItem>
);


const CustomFieldFullWidth = props => (
	<GridItem xs={12} sm={12} md={12} style={{ marginBottom: '25px' }}>
		<FormControl fullWidth>
			<Field {...props} />
		</FormControl>
	</GridItem>
);

const checkItem = (label, name, changeFunc) => {
  return (
    
    <GridItem xs={4} sm={4} md={2} >
            <FormControl style={{marginBottom: "-30px", paddingBottom: "-30px"}}>
              <Field
                component={FormCheckbox}
                name={name}
                onChange={(e, f, g, h) => {
                  changeFunc(h, f)

                }}

              />
            </FormControl>
            </GridItem>
  );
};


class PersonalDetail extends React.Component {
  componentDidMount() 
  {
    this.props.scrollMeBar();
  }

  changeReason(name)
  {
    var reasons = this.props.fnaReasons;
    reasons[name] = !reasons[name];
    console.log(reasons)
    this.props.changePersonal("fnaReasons", reasons)

  }
  

 

  render()
  {
    var clientD = "";
    if(this.props.state.client)
      clientD = this.props.state.client.first_name + " " + this.props.state.client.surname
    return(
      <div className="contentWithStepper">
       
        <Card>
          <CardContent>
            <CustomCardHeading
              subheading={"Financial Needs Analysis"}
              caption={clientD}
              headline={"FNA Details"}
            />

            <Grid container>
              
                    <CustomFieldFullWidth
                    name={'description'}
                    component={FormInput}
                    checkValidation={this.props.checkValidation}
                    label={'FNA Description *'}
                    isrequired={true}
                    //validate={[required]}
                  />

                  <GridItem xs={12} sm={12} md={12} style={{ marginBottom: '25px' }}></GridItem>


                
                <GridItem xs={12} sm={12} md={12} style={{ marginBottom: '-8px' }}>
                  <Typography style={{fontSize: '16px'}}>
                    Please select the reasons for FNA
                  </Typography>
                </GridItem>
                  
                <GridItem xs={12} sm={12} md={6}  style={{ marginBottom: '55px' }}>
                  <GridItem xs={12} sm={12} md={4} style={{ marginBottom: '-10px' }}>
                    <FormControl fullWidth>
                    <div
                      key={"Death"}
                      className={'checkboxContainerMedical'}
                      //style={this.props.fnaReasons["death"] ? { backgroundColor: '#f5f5f5'} : {}}
                      onClick={() => {this.changeReason("death")}}
									  >
										  <Checkbox checked={this.props.fnaReasons["death"]} />
                      <Typography
                        style={{ marginTop: 'auto', marginBottom: "auto"}}
                      >
                      {"Death"}
                      </Typography>
									  </div>
                    </FormControl>
                  </GridItem>

                  <GridItem xs={12} sm={12} md={4} style={{ marginBottom: '-10px' }}>
                    <FormControl fullWidth>
                    <div
                      key={"Disability"}
                      className={'checkboxContainerMedical'}
                      //style={this.props.fnaReasons["disability"] ? { backgroundColor: '#f5f5f5'} : {}}
                      onClick={() => {this.changeReason("disability")}}
									  >
										  <Checkbox checked={this.props.fnaReasons["disability"]} />
                      <Typography
                        style={{ marginTop: 'auto', marginBottom: "auto"}}
                      >
                      {"Disability"}
                      </Typography>
									  </div>
                    </FormControl>
                  </GridItem>

                  <GridItem xs={12} sm={12} md={4} style={{ marginBottom: '-10px' }}>
                    <FormControl fullWidth>
                    <div
                      key={"Retirement"}
                      className={'checkboxContainerMedical'}
                      //style={this.props.fnaReasons["retirement"] ? { backgroundColor: '#f5f5f5'} : {}}
                      onClick={() => {this.changeReason("retirement")}}
									  >
										  <Checkbox checked={this.props.fnaReasons["retirement"]} />
                      <Typography
                        style={{ marginTop: 'auto', marginBottom: "auto"}}
                      >
                      {"Retirement"}
                      </Typography>
									  </div>
                    </FormControl>
                  </GridItem>
                </GridItem>

                <GridItem xs={12} sm={12} md={6} style={{ marginBottom: '25px', marginTop: '-25px' }}>

                  <CustomFieldFullWidth
                    name={'marginalTax'}
                    suffix="%"
                    component={NumberInput}
                    checkValidation={this.props.checkValidation}
                    label={'Marginal Tax Rate %*'}
                    isrequired={true}
                    onChange = {(e, f, g, h) => 
                      {
                        this.props.changePersonal(h,f)
                      }}
                    //validate={[required]}
                  />

                  <Grid container style={{ marginBottom: '0px', marginTop: '50px' }}>
                    
                    <GridItem xs={1} sm={1} md={10} style={{ marginBottom: '0px', marginTop: '0px' }}>
                      <Typography style={{fontSize: '16px'}}>
                        Do you have a capital loss for CGT purposes which can be carried forward?
                      </Typography>
                    </GridItem>

                     
                    {checkItem("", "capitalLoss", this.props.changePersonal)}
                    {
                  this.props.state.capitalLoss == true &&

                 
                      <CustomFieldFullWidth
                      name={'capitalLossAmount'}
                      prefix="R"
                      component={NumberInput}
                      checkValidation={this.props.checkValidation}
                      label={'Amount*'}
                      isrequired={true}
                      //validate={[required]}
                      onChange = {(e, f, g, h) => 
                        {
                          this.props.changePersonal(h,f)
                        }}
                    />
                 
                }
                  </Grid>
                </GridItem>

                

                

                  <Grid container>
                    
                    <GridItem xs={24} sm={24} md={6} style={{ marginBottom: '25px' }}>
                      <Grid container>
                        <GridItem xs={6} sm={6} md={10} style={{ marginBottom: '0px' }}>
                          <Typography style={{fontSize: '16px'}}>
                            Are there any assets which are excluded from accrual? (Client)
                          </Typography>
                        </GridItem>
                          {checkItem("", "accrualExclution", this.props.changePersonal)}

                          {
                      this.props.state.accrualExclution &&

                      
                      <CustomFieldFullWidth
                        name={'accrualExcludedClient'}
                        prefix="R"
                        component={NumberInput}
                        checkValidation={this.props.checkValidation}
                        label={'Asset value excluded from accrual (inheritance) R*'}
                        isrequired={true}
                        //validate={[required]}
                        onChange = {(e, f, g, h) => 
                          {
                            this.props.changePersonal(h,f)
                          }}
                      />
                       
                    }
                     {
                      this.props.state.accrualExclution &&

                      
                      <CustomFieldFullWidth
                        name={'accrualExcludedMarrageClient'}
                        prefix="R"
                        component={NumberInput}
                        checkValidation={this.props.checkValidation}
                        label={'Asset value excluded at marriage (in terms of ANC) R*'}
                        isrequired={true}
                        //validate={[required]}
                        onChange = {(e, f, g, h) => 
                          {
                            this.props.changePersonal(h,f)
                          }}
                      />
                        
                    }
                      </Grid>
                    </GridItem>

                   
                   
                    
                    <GridItem xs={24} sm={24} md={6} style={{ marginBottom: '25px' }}>
                      <Grid container>
                        <GridItem xs={6} sm={6} md={10} style={{ marginBottom: '0px' }}>
                          <Typography style={{fontSize: '16px'}}>
                            Are there any assets which are excluded from accrual? (spouse)
                          </Typography>
                        </GridItem>
                          {checkItem("", "accrualExclutionSpouse", this.props.changePersonal)}

                          {
                      this.props.state.accrualExclutionSpouse &&

                      
                      <CustomFieldFullWidth
                        name={'accrualExcludedSpouse'}
                        prefix="R"
                        component={NumberInput}
                        checkValidation={this.props.checkValidation}
                        label={'Asset value excluded from accrual (inheritance) R*'}
                        isrequired={true}
                        //validate={[required]}
                        onChange = {(e, f, g, h) => 
                          {
                            this.props.changePersonal(h,f)
                          }}
                      />
                        
                    }
                    {
                      this.props.state.accrualExclutionSpouse &&

                      
                      <CustomFieldFullWidth
                        name={'accrualExcludedMarrageSpouse'}
                        prefix="R"
                        component={NumberInput}
                        checkValidation={this.props.checkValidation}
                        label={'Asset value excluded at marriage (in terms of ANC) R*'}
                        isrequired={true}
                        //validate={[required]}
                        onChange = {(e, f, g, h) => 
                          {
                            this.props.changePersonal(h,f)
                          }}
                      />
                        
                    }
                      </Grid>
                    </GridItem>

                   

                    

                    
                  </Grid>
                  <GridItem xs={12} sm={12} md={6} style={{ marginBottom: '25px', marginTop: '-25px' }}>
                  <CustomFieldFullWidth
                    name={'execFee'}
                    suffix="%"
                    component={NumberInput}
                    checkValidation={this.props.checkValidation}
                    label={'Executors Fee %*'}
                    isrequired={true}
                    //validate={[required]}
                    onChange = {(e, f, g, h) => 
                      {
                        this.props.changePersonal(h,f)
                      }}
                  />
                    </GridItem>
                  

                  
                    <GridItem xs={24} sm={24} md={6} style={{ marginBottom: '25px' }}>
                    <Grid container>
                      <GridItem xs={6} sm={6} md={10} style={{ marginBottom: '0px' }}>
                        <Typography style={{fontSize: '16px'}}>
                          Include vat on executor's fee?
                        </Typography>
                  </GridItem>
                  
                      

                    
                    {checkItem("", "execTax", this.props.changePersonal)}
                    </Grid>
                    </GridItem>
                
                    <GridItem xs={12} sm={12} md={6} style={{ marginBottom: '25px', marginTop: '-25px' }}>
                  <CustomFieldFullWidth
                    name={'funeralCost'}
                    prefix="R"
                    component={NumberInput}
                    checkValidation={this.props.checkValidation}
                    label={'Funeral Costs R*'}
                    isrequired={true}
                    //validate={[required]}
                    onChange = {(e, f, g, h) => 
                      {
                        this.props.changePersonal(h,f)
                      }}
                  />
                    </GridItem>

                    <GridItem xs={12} sm={12} md={6} style={{ marginBottom: '25px', marginTop: '-25px' }}>
                  <CustomFieldFullWidth
                    name={'adminCost'}
                    prefix="R"
                    component={NumberInput}
                    checkValidation={this.props.checkValidation}
                    label={'Administration Costs R*'}
                    isrequired={true}
                    //validate={[required]}
                    onChange = {(e, f, g, h) => 
                      {
                        this.props.changePersonal(h,f)
                      }}
                  />
                    </GridItem>
               
                    <GridItem xs={12} sm={12} md={6} style={{ marginBottom: '25px', marginTop: '-25px' }}>
                  <CustomFieldFullWidth
                    name={'inflation'}
                    suffix="%"
                    component={NumberInput}
                    checkValidation={this.props.checkValidation}
                    label={'Inflation %*'}
                    isrequired={true}
                    //validate={[required]}
                    onChange = {(e, f, g, h) => 
                      {
                        this.props.changePersonal(h,f)
                      }}
                  />
                    </GridItem>

                    <GridItem xs={12} sm={12} md={6} style={{ marginBottom: '25px', marginTop: '-25px' }}>
                  <CustomFieldFullWidth
                    name={'investmentGrowth'}
                    suffix="%"
                    component={NumberInput}
                    checkValidation={this.props.checkValidation}
                    label={'Net Growth On Investments %*'}
                    isrequired={true}
                    //validate={[required]}
                    onChange = {(e, f, g, h) => 
                      {
                        this.props.changePersonal(h,f)
                      }}
                  />
                    </GridItem>

                    <GridItem xs={24} sm={24} md={6} style={{ marginBottom: '25px' }}>
                    <Grid container>
                      <GridItem xs={6} sm={6} md={10} style={{ marginBottom: '0px' }}>
                        <Typography style={{fontSize: '16px'}}>
                          70% on farm property?
                        </Typography>
                  </GridItem>
                  
                      

                    
                    {checkItem("", "percentageOnFarm", this.props.changePersonal)}
                    </Grid>
                    </GridItem>

                    <GridItem xs={24} sm={24} md={6} style={{ marginBottom: '25px' }}>
                    <Grid container>
                      <GridItem xs={6} sm={6} md={10} style={{ marginBottom: '0px' }}>
                        <Typography style={{fontSize: '16px'}}>
                          Will your spouse claim the accrual value?
                        </Typography>
                  </GridItem>
                    {checkItem("", "spouseAccrual", this.props.changePersonal)}

                    
                    </Grid>
                    </GridItem>

                   

                   

                    <GridItem xs={24} sm={24} md={6} style={{ marginBottom: '25px' }}>
                    <Grid container>
                      <GridItem xs={6} sm={6} md={10} style={{ marginBottom: '0px' }}>
                        <Typography style={{fontSize: '16px'}}>
                          Does your spouse inherit the full residue?
                        </Typography>
                  </GridItem>
                  
                      

                    
                    {checkItem("", "spouseInheritFull", this.props.changePersonal)}

                    {
                      !this.props.state.spouseInheritFull &&
                      <GridItem xs={24} sm={24} md={12} style={{ marginTop: '0px', marginLeft: '-15px' }}>
                      <CustomFieldFullWidth
                        name={'residueAmount'}
                        suffix="%"
                        component={NumberInput}
                        checkValidation={this.props.checkValidation}
                        label={'Spouse Residue Inheretance %*'}
                        isrequired={true}
                        //validate={[required]}
                        onChange = {(e, f, g, h) => 
                          {
                            this.props.changePersonal(h,f)
                          }}
                      />
                        </GridItem>

                    }
                    </Grid>
                    </GridItem>

                    
                    <GridItem xs={24} sm={24} md={6} style={{  }}>
                    <Grid container>
                      <GridItem xs={6} sm={6} md={10} style={{ marginBottom: '0px' }}>
                        <Typography style={{fontSize: '16px'}}>
                          Did a previous spouse die while married to you?
                        </Typography>
                  </GridItem>
                    {checkItem("", "spouseDeath", this.props.changePersonal)}

                    {
                      this.props.state.spouseDeath &&

                      <GridItem xs={12} sm={12} md={12} style={{ marginBottom: '25px', marginTop: '0px', marginLeft: '-15px' }}>
                      <CustomFieldFullWidth
                        name={'rebateUsed'}
                        prefix="R"
                        component={NumberInput}
                        checkValidation={this.props.checkValidation}
                        label={'Amount estate duty rebate used R*'}
                        isrequired={true}
                        //validate={[required]}
                        onChange = {(e, f, g, h) => 
                          {
                            this.props.changePersonal(h,f)
                          }}
                      />
                        </GridItem>

                    }
                    </Grid>
                    </GridItem>

                    
   

                    <GridItem xs={24} sm={24} md={6} style={{ marginBottom: '25px' }}>
                    <Grid container>
                      <GridItem xs={6} sm={6} md={10} style={{ marginBottom: '0px' }}>
                        <Typography style={{fontSize: '16px'}}>
                        Residue not going to spouse, to benefit of dependents?
                        </Typography>
                  </GridItem>
                  
                      

                    
                    {checkItem("", "residueNotTo", this.props.changePersonal)}
                    </Grid>
                    </GridItem>

                    
                    


                    
              
            </Grid>
          </CardContent>
        </Card>

      </div>

    );
  }
}

export default PersonalDetail;



// WEBPACK FOOTER //
// ./src/views/Fna/steps/PersonalDetail.jsx